import {
  ExpressFormMenuKey,
  ExpressStoreKey,
  ExpressSubmissionData,
} from "@/pages/ExpressForm/express-data";
import { ServiceProvider } from "@/types/ServiceProvider";
import {
  ExpressFormStorage,
  getExpressData,
  getExpressSectionsData,
  setExpressSubmitted,
} from "../express-data";
import { submitExpressRecord } from "@/services/api/formApi";
import { ExpressUiInfo } from "@/types";
import {
  isExpressMultiAccountFormComplete,
  isExpressIntestacyFormComplete,
  isExpressSingleAccountFormComplete,
  multiAccountDataForSubmission,
  singleAccountDataForSubmission,
} from "@/helpers/express-helpers";
interface FetchState {
  busy: boolean;
  error?: string;
}
export function handleSingleAccountSubmit(
  sp: ServiceProvider,
  uiInfo: ExpressUiInfo,
  setState: React.Dispatch<React.SetStateAction<FetchState>>,
  next: () => void
) {
  const data: ExpressSubmissionData = singleAccountDataForSubmission(uiInfo);
  console.log(data[ExpressStoreKey.SingleAccount]);

  if (!isExpressSingleAccountFormComplete(uiInfo, sp, data)) {
    setState({
      busy: false,
      error: "Please verify that all steps are valid (have a check on the menu) before submitting.",
    });
    return;
  }

  const [isIntestacyComplete, errMsg] = isExpressIntestacyFormComplete(sp, data, uiInfo);

  if (!isIntestacyComplete && errMsg) {
    setState({
      busy: false,
      error: errMsg,
    });
    return;
  }
  setState({ busy: true });

  // if (account?.property?.occupier?.id === "notifier") {
  //   account.property.occupier.notifier = true;
  //   delete account.property.occupier.id;
  // }

  // if (account?.responsible?.id === "notifier") {
  //   account.responsible.notifier = true;
  //   delete account.responsible.id;
  // }

  if (data[ExpressStoreKey.SingleAccount]?.property?.occupier?.id === "notifier") {
    data[ExpressStoreKey.SingleAccount].property.occupier.notifier = true;
    delete data[ExpressStoreKey.SingleAccount].property.occupier.id;
  }

  if (data[ExpressStoreKey.SingleAccount]?.responsible?.id === "notifier") {
    data[ExpressStoreKey.SingleAccount].responsible.notifier = true;
    delete data[ExpressStoreKey.SingleAccount].responsible.id;
  }

  const payload = {
    ...data,
    accounts: [data[ExpressStoreKey.SingleAccount]],
  };
  submitExpressRecord(payload).then(
    ({ formUrl }) => {
      setState({ busy: false });
      setExpressSubmitted(formUrl);
      next();
    },
    (error) => {
      if (error.message === "email_exists") {
        setState({
          busy: false,
          error: "This email already exists, please sign in",
        });
        return;
      }
      setState({
        busy: false,
        error: `Unexpected failure. Please try again or contact customer support. with error message${error.toString()}`,
      });
    }
  );
}
export function handleMultiAccountSubmit(
  sp: ServiceProvider,
  uiInfo: ExpressUiInfo,
  setState: React.Dispatch<React.SetStateAction<FetchState>>,
  next: () => void
) {
  const data: ExpressSubmissionData = multiAccountDataForSubmission(uiInfo);

  if (!isExpressMultiAccountFormComplete(uiInfo, sp, data)) {
    setState({
      busy: false,
      error: "Please verify that all steps are valid (have a check on the menu) before submitting.",
    });
    return;
  }

  const [isIntestacyComplete, errMsg] = isExpressIntestacyFormComplete(sp, data, uiInfo);

  if (!isIntestacyComplete && errMsg) {
    setState({
      busy: false,
      error: errMsg,
    });
    return;
  }

  setState({ busy: true });

  const payload = {
    ...data,
    accounts: data[ExpressStoreKey.MultiAccount],
  };

  submitExpressRecord(payload).then(
    ({ formUrl }) => {
      setState({ busy: false });
      setExpressSubmitted(formUrl);
      next();
    },
    (error) => {
      if (error.message === "email_exists") {
        setState({
          busy: false,
          error: "This email already exists, please sign in",
        });
        return;
      }
      setState({
        busy: false,
        error: `Unexpected failure. Please try again or contact customer support. with error message${error.toString()}`,
      });
    }
  );
}

export function handleSubmit(
  sp: ServiceProvider,
  uiInfo: ExpressUiInfo,
  setState: React.Dispatch<React.SetStateAction<FetchState>>,
  next: () => void
) {
  if (sp.expressMultiAccount) {
    handleMultiAccountSubmit(sp, uiInfo, setState, next);
  } else {
    handleSingleAccountSubmit(sp, uiInfo, setState, next);
  }
}
